<script>
	export let disabled = false;

	let className = $$props.class ? " " + $$props.class : "";
</script>

<button class={className} on:click|preventDefault {disabled} type="submit">
	<slot></slot>
</button>

<style>
	button {
		color: var(--color-body);
		background-color: transparent;
		border: none;
		padding: 0;
		font-family: "Proxima Nova";
		font-size: 18px;
		font-weight: 600;
		border-bottom: solid 1px var(--color-primary);
		font-weight: bold;
	}

	button:hover {
		color: var(--color-primary);
	}
</style>
